import React, { useState } from 'react';
import { Flex, Text } from '@radix-ui/themes';
import { Input } from '../ui/input';
import { cn } from '@/lib/utils';

interface PasswordInputProps extends React.InputHTMLAttributes<HTMLInputElement> { }

const PasswordInput = React.forwardRef<HTMLInputElement, PasswordInputProps>(
  ({ className, type, ...props }, ref) => {
    const [showPassword, setShowPassword] = useState(false);

    const togglePasswordVisibility = () => {
      setShowPassword(!showPassword);
    };

    return (
      <Flex className="relative items-center" ref={ref}>
        <Input
          {...props}
          type={showPassword ? 'text' : 'password'}
          className={cn("pr-16 select-none", className)}
        />
        <Flex
          onClick={togglePasswordVisibility}
          className="absolute right-3 h-8 cursor-pointer w-10"
          justify="end"
          align="center"
        >
          <Text className="select-none text-gray-600 text-sm">
            {showPassword ? 'Hide' : 'Show'}
          </Text>
        </Flex>
      </Flex>
    );
  }
);
PasswordInput.displayName = "PasswordInput"

export default PasswordInput;
